import React from 'react'
import { Modal, Button, Box, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { mono, boFont } from '@components/systems/backoffice/backoffice.tokens'

interface ProductDeleteConfirmationModalProps {
	open: boolean
	onClose: () => void
	onDelete: () => void
	productName: string
}

/** 제품 삭제 확인 — 빨간 아이콘 없이 문장이 위험을 말한다. 취소는 텍스트, 삭제는 고스트 */
export const ProductDeleteConfirmationModal: React.FC<
	ProductDeleteConfirmationModalProps
> = ({ open, onClose, onDelete, productName }) => {
	return (
		<Modal
			open={open}
			onClose={onClose}
			aria-labelledby="delete-confirmation-title"
			aria-describedby="delete-confirmation-description"
		>
			<Box component="div" sx={styles.modalContent}>
				<Box component="div" sx={styles.head}>
					<Box component="span" sx={styles.kicker}>
						Delete
					</Box>
					<IconButton onClick={onClose} size="small" aria-label="close">
						<CloseIcon fontSize="small" />
					</IconButton>
				</Box>
				<Box component="h2" id="delete-confirmation-title" sx={styles.title}>
					제품 삭제 확인
				</Box>
				<Box component="p" id="delete-confirmation-description" sx={styles.description}>
					정말로 <strong>{productName}</strong>을(를) 삭제하시겠습니까?
				</Box>
				<Box component="p" sx={styles.warning}>
					이 작업은 되돌릴 수 없습니다.
				</Box>
				<Box sx={styles.buttonContainer}>
					<Button variant="text" onClick={onClose}>
						취소
					</Button>
					<Button variant="outlined" onClick={onDelete}>
						삭제하기
					</Button>
				</Box>
			</Box>
		</Modal>
	)
}

const styles = {
	modalContent: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 420,
		maxWidth: 'calc(100vw - 32px)',
		backgroundColor: mono.surface,
		border: `1px solid ${mono.line}`,
		boxShadow: '0 30px 60px rgba(20, 24, 32, 0.12)',
		padding: '24px 28px 28px',
		borderRadius: 0,
		textAlign: 'left',
		fontFamily: boFont.ui,
		outline: 'none',
	},
	head: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	kicker: {
		fontSize: 11,
		letterSpacing: '.24em',
		textTransform: 'uppercase',
		color: mono.faint,
		fontWeight: 500,
	},
	title: {
		margin: '8px 0 16px',
		fontSize: 24,
		fontWeight: 300,
		lineHeight: 1.15,
		color: mono.ink,
	},
	description: {
		margin: '0 0 6px',
		fontSize: 14,
		fontWeight: 300,
		lineHeight: 1.6,
		color: mono.ink,
		strong: { fontWeight: 500 },
	},
	warning: {
		margin: '0 0 24px',
		fontSize: 13,
		fontWeight: 300,
		color: mono.dim,
	},
	buttonContainer: {
		display: 'flex',
		justifyContent: 'flex-end',
		gap: 1,
		paddingTop: 2,
		borderTop: `1px solid ${mono.line}`,
	},
}
